import React from "react";
import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps } from "styled-system";

interface StyledProps extends LayoutProps, SpaceProps {
  children?: React.ReactNode;
}

const StyledContainer = styled.div<StyledProps>`
  display: inline-block;
  ${space}
  ${layout}
`;

const PoundSignInCircleSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="pound-sign-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          d="M10.1875 20C15.7103 20 20.1875 15.5228 20.1875 10C20.1875 4.47715 15.7103 0 10.1875 0C4.66465 0 0.1875 4.47715 0.1875 10C0.1875 15.5228 4.66465 20 10.1875 20ZM13.1887 13.8571C13.738 13.8571 14.1875 14.3393 14.1875 14.9286C14.1875 15.5446 13.738 16 13.1887 16H7.19569C6.79616 16 6.44657 15.7857 6.27178 15.4107C6.12195 15.0357 6.17189 14.5804 6.4216 14.2589C7.04587 13.4286 7.39546 12.3839 7.39546 11.3393V10.8571H6.99593C6.54645 10.8571 6.19686 10.4821 6.19686 10C6.19686 9.54464 6.54645 9.14286 6.99593 9.14286H7.39546V7.48214C7.39546 5.58036 8.84376 4 10.6167 4C10.9663 4 11.3159 4.08036 11.6405 4.1875L13.4883 4.85714C14.0127 5.04464 14.2874 5.66071 14.1126 6.22321C13.9378 6.78571 13.3884 7.08036 12.8641 6.89286L11.0162 6.22321C10.8914 6.16964 10.7415 6.14286 10.6167 6.14286C9.94247 6.14286 9.39312 6.75893 9.39312 7.48214V9.14286H11.7903C12.2148 9.14286 12.5894 9.54464 12.5894 10C12.5894 10.4821 12.2148 10.8571 11.7903 10.8571H9.39312V11.3393C9.39312 12.1964 9.21832 13.0804 8.91867 13.8571H13.1887Z"
          fill="#1D2948"
        />
      </svg>
    </StyledContainer>
  );
};

export default PoundSignInCircleSVG;
